import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, PropType } from 'vue'
import dayjs from 'dayjs'
import { useDisplay } from '@/composables/useDisplay'
import { DateTime } from 'luxon'


export default /*#__PURE__*/_defineComponent({
  __name: 'CUDatePicker',
  props: {
  label: {
    type: String,
    default: '',
  },
  id: {
    type: String,
    default: '',
  },
  rules: {
    type: Array,
    default: () => [],
  },
  hideDetails: {
    type: Boolean,
    default: false,
  },
  value: {
    type: String,
    required: true,
  },
  displayValue: {
    type: String,
    default: '',
  },
  min: {
    type: String,
    default: '',
  },
  minDate: {
    type: Object as PropType<DateTime>,
    default: '',
  },
  top: {
    type: Boolean,
    default: false,
  },
  bottom: {
    type: Boolean,
    default: false,
  },
  right: {
    type: Boolean,
    default: false,
  },
  left: {
    type: Boolean,
    default: false,
  },
  origin: {
    type: String,
    default: '',
  },
  months: {
    type: Number,
    default: 1,
  },
  placeholder: {
    type: String,
    default: '',
  },
  timezone: {
    type: String,
    default: 'UTC',
  },
  disabled: {
    type: Boolean,
    default: false
  }
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;





const isOpen = ref(false)

const inputDisplayText = computed(() => {
  return props.displayValue
})

const isMultiMonth = computed(() => {
  return (props.months || 1) > 1
})

const { smAndDown } = useDisplay()
const effectiveMonths = computed(() => {
  return smAndDown.value ? 1 : props.months
})

function handleVCEmit(e: string) {
  emit('input', !!e ? dayjs(e).tz(props.timezone).format('YYYY-MM-DD') : '')
}

function toggleMenu(): void {
  if (!props.disabled) {
    isOpen.value = !isOpen.value
  }
}

watch(() => props.value, () => {
  isOpen.value = false
})

// VC Date Picker styles
const currentDayStyles = {
  highlight: {
    style: {
      height: '36px',
      width: '36px',
      background: '#08A6F0',
    },
    contentStyle: {
      fontWeight: '600',
      color: '#fff',
    },
  },
  dates: new Date(),
}

const selectedDayStyles = {
  highlight: {
    style: {
      height: '36px',
      width: '36px',
      background: '#000',
    },
    contentStyle: {
      fontWeight: '700',
      color: '#fff',
    },
  },
}

return { __sfc: true,props, emit, isOpen, inputDisplayText, isMultiMonth, smAndDown, effectiveMonths, handleVCEmit, toggleMenu, currentDayStyles, selectedDayStyles }
}

})